import { type ValueFormatterParams } from 'ag-grid-community';

import { DateParser } from '../../../utils';

export const dateTimeFormatter = (params: ValueFormatterParams): string => {
  if (!params.value) {
    return '';
  }

  return DateParser.toDateTimeString(params.value);
};

export const dateFormatter = (params: ValueFormatterParams): string => {
  if (!params.value) {
    return '';
  }

  return DateParser.toString(params.value);
};

export const passthroughFormatter = (params: ValueFormatterParams): string => {
  return !params.value ? '' : params.value;
};
